import React, { useState } from "react";
import Page from "../2/Controls/Page";
import Loader from "../Loader";
import axios from "axios";
import Input from "../2/Controls/Input";

function PincodeMissingWHInbound() {
  const [SONO, setSONO] = useState("");
  const [loading, setLoading] = useState("");

  const fetchMissingSO = async () => {
    if (!SONO.trim()) {
      alert("Please enter missing SO No");
      return;
    }

    setLoading(true);

    try {
      // Example API calls (replace URLs with your real ones)

      // Sequential call (one after another)

      try {
        const res = await axios.post(
          "https://backend-197598313260.asia-south1.run.app/v1/viniculum/callback/order",
          {
            order: [
              {
                order_no: SONO,
              },
            ],
          }
        );
        console.log(res);
      } catch (error) {
        console.log("error", error);
        alert("Error creating SO");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Page
      title="Missing WH Inbound"
      showSaveButton={false}
      showCancelButton={false}
      processing={loading}
    >
      {loading && <Loader show={loading} />}

      <div
        style={{
          padding: "20px",
          fontFamily: "Arial, sans-serif",
          maxWidth: "600px",
          margin: "0 auto",
        }}
      >
        {/* --- Input Fields --- */}
        <div style={{ marginBottom: "20px" }}>
          <Input
            type="text"
            label=" Missing SO No"
            value={SONO}
            onChange={(value) => {
              setSONO(value);
            }}
            placeholder="Enter missing SO NO"
            style={{
              width: "100%",
              padding: "10px",
              border: "1px solid #ccc",
              borderRadius: "4px",
            }}
          />
        </div>

        {/* --- Convert Button --- */}
        <button
          onClick={fetchMissingSO}
          disabled={loading}
          style={{
            padding: "12px 24px",
            backgroundColor: "#1976d2",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
            width: "100%",
            fontSize: "16px",
          }}
        >
          {loading ? "Processing..." : "Fetch Missing SO"}
        </button>
      </div>
    </Page>
  );
}

export default PincodeMissingWHInbound;
